export default {
	NOTIFICATIONS_RECEIVED: "notifications/NOTIFICATIONS_RECEIVED"
}